import {GqlModel} from "./graphql.model";
import {JSONModel, jsonProperty} from "../json.model";
import {FilteredList, FilteredListOptions} from "../helpers/filtered-list";

export class SuccessResultGqlModel extends GqlModel {
  @jsonProperty("boolean") success: boolean;
}

export interface EditableListItem {
  editing: boolean;
}

export class NameIndexEditingItemGqlModel extends JSONModel implements EditableListItem {
  @jsonProperty("string") name: string;
  @jsonProperty("number") index: number;

  editing: boolean = false;
}

export class NameIndexEditingGqlModel<T extends NameIndexEditingItemGqlModel> extends FilteredList<T> {
  constructor(options: FilteredListOptions<T>, items: T[] | string[], clazz: {new (data: any): T}) {
    if (items && clazz) {
      if (typeof items[0] === "string") {
        items = (items as string[]).map((name, index) => new clazz({name, index})); // eslint-disable-line new-cap
      } else {
        items = (items as any[]).map((obj, index) => new clazz({index, ...obj})); // eslint-disable-line new-cap
      }
    }

    if (!items) {
      items = [];
    }

    for (const item of items) {
      if (typeof item === "string" && !clazz) {
        console.error(`Expected object but got string for item ${item} and there was no class given!`);
        throw new Error("An unexpected error occurred.");
      }
    }

    super({
      ...options,
      indexField: "index",
      formKeys: ["name"],
      items: items as T[],
    });
  }
}

export class DefaultNameIndexEditingGqlModel extends NameIndexEditingGqlModel<NameIndexEditingItemGqlModel> {
  constructor(items: NameIndexEditingItemGqlModel[] | string[]) {
    super({}, items, NameIndexEditingItemGqlModel);
  }
}
